import { render, staticRenderFns } from "./ShippingHeaderList.vue?vue&type=template&id=38143ee4"
import script from "./ShippingHeaderList.vue?vue&type=script&lang=js"
export * from "./ShippingHeaderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports